export default "__VITE_ASSET__CZ5$cGL8__"